var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-loading-progress app-loading-progress--bars"},[_c('scale-loader',{attrs:{"loading":true,"color":_vm.color,"height":_vm.height,"width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }